var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:[
    'dropdown-item',
    {
      'dropdown-item--title': _vm.isGroupTitle,
      'disabled': _vm.disabled,
      'active': _vm.isActive
    }
  ]},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }